export default __webpack_public_path__ + "static/jonar-logo-f7cca7e9c4ccbdeb4e5cad5a09686242.jpg";